import { Injectable } from "@nestjs/common";
import { AssetLicenseLogsDto } from "../dto/license-log.dto";
import { assetsLogTransactions } from "./license-log.entity";
// import { assetMainanceTransactions } from "./license-log.entity";

@Injectable()
export class LicenseLogsAdapter{
    public convertDtotoLicenseLogEntity(assetTransfersDto:AssetLicenseLogsDto,isUpdate: boolean = false) : assetsLogTransactions{
        const assetLicense = new assetsLogTransactions();
        assetLicense.transactionLicenseId=assetTransfersDto.assetMaintainanceTransactionsId;
        assetLicense.licenseId = assetTransfersDto.licenseId;
        assetLicense.licenseName = assetTransfersDto.licenseName;
        assetLicense.referenceNumber = assetTransfersDto.referenceNumber;
        assetLicense.company = assetTransfersDto.company;
        assetLicense.licenseNumber = assetTransfersDto.licenseNumber;
        assetLicense.responsibility = assetTransfersDto.responsibility;
        assetLicense.expiryDate = assetTransfersDto.expiryDate;
        assetLicense.renewalPersonName=assetTransfersDto.renewalPersonName;
        assetLicense.renewalStartDate= assetTransfersDto.renewalStartDate;
        assetLicense.renewalExpiryDate= assetTransfersDto.renewalExpiryDate;
        assetLicense.isActive = assetTransfersDto.isActive;
        assetLicense.createdAt = assetTransfersDto.createdAt;
        assetLicense.createdUser = assetTransfersDto.createdUser;
        assetLicense.updatedAt = assetTransfersDto.updatedAt;
        assetLicense.updatedUser = assetTransfersDto.updatedUser;
        assetLicense.versionFlag = assetTransfersDto.versionFlag;
        assetLicense.plantId = assetTransfersDto.plantId;
        return assetLicense;

    }
   
    public convertEntitytoAssetLicenseDto(assetLicense:assetsLogTransactions) : AssetLicenseLogsDto{
        const assetLicenseDto = new AssetLicenseLogsDto();
        assetLicenseDto.assetMaintainanceTransactionsId = assetLicense.transactionLicenseId;
        assetLicenseDto.licenseId = assetLicense.licenseId;
        assetLicenseDto.licenseName = assetLicense.licenseName;
        assetLicenseDto.referenceNumber = assetLicense.referenceNumber;
        assetLicenseDto.company = assetLicense.company;
        assetLicenseDto.licenseNumber = assetLicense.licenseNumber;
        assetLicenseDto.responsibility = assetLicense.responsibility;
        assetLicenseDto.expiryDate = assetLicense.expiryDate;
        assetLicenseDto.renewalPersonName = assetLicense.renewalPersonName;
        assetLicenseDto.renewalStartDate = assetLicense.renewalStartDate;
        assetLicenseDto.renewalExpiryDate = assetLicense.renewalExpiryDate;
        assetLicenseDto.isActive = assetLicense.isActive;
        assetLicenseDto.createdAt = assetLicense.createdAt;
        assetLicenseDto.createdUser = assetLicense.createdUser;
        assetLicenseDto.updatedAt = assetLicense.updatedAt;
        assetLicenseDto.updatedUser = assetLicense.updatedUser;
        assetLicenseDto.versionFlag = assetLicense.versionFlag;
        assetLicense.plantId = assetLicense.plantId;
      
        return assetLicenseDto;

    }

 
}